export const USER_SET = 'USER_SET';
export const SIGN_IN_GOOGLE = 'SIGN_IN_GOOGLE';
export const SIGN_IN_EMAIL = 'SIGN_IN_EMAIL';
export const SIGN_UP = 'SIGN_UP';
export const LOGOUT = 'LOGOUT';
